import React from 'react'
import FileManager from '../../components/FileManager/FileManager'

const Efiling = props => {
	const {fileManagerType} = props

	return (
		<div>
			<FileManager 
				fileManagerType={fileManagerType}
			/>
		</div>
	)
}


export default Efiling